__turbopack_context__.v({
  "UiVerticalTabs": "J7xChG_UiVerticalTabs",
  "UiVerticalTabs__list": "J7xChG_UiVerticalTabs__list",
  "UiVerticalTabs__marker": "J7xChG_UiVerticalTabs__marker",
  "UiVerticalTabs__tab": "J7xChG_UiVerticalTabs__tab",
  "UiVerticalTabs__tab--sub": "J7xChG_UiVerticalTabs__tab--sub",
});
